import React from 'react';
import ContentItemLocationsBlock from 'js/components/content-item/ContentItem.locations-block';
import { useSelector } from 'react-redux';
import { getAllLocations } from 'js/store/locations/Locations.selectors';

const ContentItemLocationsGrid = () => {
  const allLocations = useSelector((state) => getAllLocations(state));
  const renderContentItems = () => {
    return allLocations.map((item) => {
      return <ContentItemLocationsBlock item={item} key={item.id} />;
    });
  };

  return <ul className="content-item__grid content-item__grid--locations">{renderContentItems()}</ul>;
};

export default ContentItemLocationsGrid;
